import { createApp } from 'vue';
import MainNotification from '@/components/MainNotification.vue'


export let notify;

export default {
  install(app, store) {
    const notificationApp = createApp(MainNotification);
    notificationApp.use(store);

    const notificationInstance = notificationApp.mount(document.createElement('div'));

    document.body.appendChild(notificationInstance.$el);

    notify = (message, color="black", duration=3000) => {
      notificationInstance.show(message, color, duration);
    };
    app.config.globalProperties.$notify = notify;
    store.$notify = app.config.globalProperties.$notify;
  },
};